let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("di0jw")).then(() => parcelRequire('aoo70'));